import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ResponsiveLayoutService } from 'src/app/services/responsive-layout.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AdminTableComponent } from 'src/app/shared/admin-table/admin-table.component';
import { Comuna } from 'src/app/models/comuna';
import { REGIONES_COMUNA } from 'src/app/shared/utils/regiones';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/services/toast.service';


@Component({
  selector: 'app-comuna',
  templateUrl: './comuna.component.html',
  styleUrls: ['./comuna.component.css']
})
export class ComunaComponent implements OnInit {

  data$!: string;
  mapHeader = {
    id: { display: '#', data: null },
    name: { display: 'Comuna', data: null },
    code: { display: 'Código', data: null },
    actions: {
      display: 'Acciones',
      sort: false,
      data: () => {
        return `<button class="btn btn-link btn-edit">
                    <svg class="bi" width="20" height="20" fill="currentColor">
                        <use xlink:href="assets/img/bootstrap-icons.svg#pencil-square" />
                    </svg>
                </button>
              `;
      },
      edit: (data: any) => { this.edit(data); },
    },
  };
  regionesComunas = REGIONES_COMUNA;

  @ViewChild('table') table!: AdminTableComponent<Comuna>;
  @ViewChild('content', { static: true }) content!: ElementRef;

  form!: FormGroup;
  constructor(
    private readonly fb: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly spinner: NgxSpinnerService,
    private readonly toastService: ToastService,
    private readonly storeService: StoreService,
    public responsiveService: ResponsiveLayoutService) {
  }

  ngOnInit(): void {
    this.data$ = 'comuna/';
    this.initForm({});
  }

  initForm(el: any) {
    this.form = this.fb.group({
      id: [el?.id],
      code: [el?.code, [Validators.required]],
      name: [el?.name, [Validators.required]],
    });
  }

  edit(ele: any) {
    this.form.reset(ele);

    this.modalService.open(this.content, { centered: true });
  }

  save() {
    if (this.form.valid) {
      this.spinner.show();
      this.storeService.put_comunas(this.form.value).subscribe({
        next: () => {
          this.toastService.showAdminSuccess('Se ha actualizado correctamente los datos');
          this.modalService.dismissAll();
          this.spinner.hide();
          this.table.reload();
        },
        error: () => {
          this.toastService.showAdminError('Por favor revise los datos');
          this.spinner.hide();
        }
      });
    }
  }

}
